import React, { FC, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './how-it-works.module.scss';
import video from '../../../images/video.svg';
import madaynVideo from '../../../videos/madayn.mp4';
import { Link } from "react-router-dom";
import Button from '../../ui-kit/button/button';

const HowItWorks: FC = () => {
    const { t } = useTranslation();
    const [isVideoPlaying, setIsVideoPlaying] = useState<boolean>(false);
    const videoRef = useRef<HTMLVideoElement>(null);

    const handlePlayVideo = () => {
        setIsVideoPlaying(true);
        if (videoRef.current) {
            videoRef.current.play();
        }
    };

    const handleVideoEnd = () => {
        setIsVideoPlaying(false);
    }

    return (
        <div id="how-it-works" className={styles.work}>
            <div className={styles.container}>
                <div className={styles.wrapper}>
                    <div className={styles.details}>
                        <h2 className={styles.header}>{t('how-it-works.header')}</h2>
                        <p className={styles.description}>{t('how-it-works.description')}</p>
                        <Link className={styles.link} to='search' style={{textDecorationLine:"none"}}>
                            <Button type='outline' className={styles.btn}>{t('how-it-works.button')}</Button>
                        </Link>
                    </div>
                    {isVideoPlaying ? (
                        <video
                            className={styles.videoPlayer}
                            ref={videoRef}
                            src={madaynVideo}
                            controls
                            autoPlay
                            onEnded={handleVideoEnd}
                        />
                    ) : (
                        <img
                            className={styles.videoPlayer}
                            src={video}
                            alt="video"
                            onClick={handlePlayVideo}
                            style={{cursor: 'pointer'}}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default HowItWorks;
